module.exports = __webpack_public_path__ + "img/course116_summary_unit_timelines.1eb34667.png";